/**
 * Guarda de rota: redireciona pra /credenciais se nao houver auth.
 */
import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getCredenciais } from '../lib/auth';

export default function Guard({ children }: { children: ReactNode }) {
  const cred = getCredenciais();
  const location = useLocation();
  if (!cred) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/credenciais?next=${next}`} replace />;
  }
  return <>{children}</>;
}
